<template>
    <img :src="url" :alt="alt" :class="myClass"  :style="'max-height: '+ height + 'px; max-width: '+ width +'px'" />
</template>

<script>
export default {
    name: 'Logo',
    props: {
        url: null,
        alt: null,
		height: null,
		width: null,
		myClass: null
	}

}
</script>